import React from "react";
import PagedCarousel from "../../homes/Carousel";
import SectionShell, { SectionTitle, SectionSubtitle } from "../../homes/SectionShell";
import usePagedSection from "../../homes/usePagedSection";
import {
  renderWebinarCard,
  renderWebinarSkeleton,
} from "../../homes/sections/WebinarCarousel";
import { apiGet } from "../../api";

// "Event Terkait" — reuses the homepage WebinarCarousel's card renderer
// verbatim so visuals stay coherent across pages. Loader hits the
// per-webinar related endpoint which shares the public cache + engagement
// hydration with the rest of the homepage.
function WebinarRelated({ slug }) {
  const loader = React.useCallback(
    async (pageIdx, perPage) => {
      const { parsedResponse } = await apiGet(
        `/api/v1/homepage/webinars/${encodeURIComponent(slug)}/related?page=${pageIdx + 1}&per_page=${perPage}`,
      );
      return {
        items: parsedResponse?.data ?? [],
        totalCount: parsedResponse?.meta?.total ?? 0,
      };
    },
    [slug],
  );

  const { items, pageIdx, setPageIdx, totalPages, loading, perPage } =
    usePagedSection({ loader });

  return (
    <SectionShell id="event-terkait">
      <SectionTitle>Event Terkait</SectionTitle>
      <SectionSubtitle>
        Jangan Lewatkan Rangkaian Webinar dan Live Online Classes Lainnya Bersama Mentor-Mentor Praktisi dan Akademisi Kami
      </SectionSubtitle>
      <PagedCarousel
        items={items}
        perPage={perPage}
        pageIdx={pageIdx}
        totalPages={totalPages}
        onPageChange={setPageIdx}
        loading={loading}
        renderItem={renderWebinarCard}
        renderSkeleton={renderWebinarSkeleton}
        ariaLabel="Event terkait carousel"
        emptyMessage="Belum ada event terkait."
      />
    </SectionShell>
  );
}

export default React.memo(WebinarRelated);
